// src/LoaderCircleIcon.tsx
import { jsx } from "react/jsx-runtime";
var LoaderCircleIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })
  }
);
var LoaderCircleIcon_default = LoaderCircleIcon;

export {
  LoaderCircleIcon_default
};
